import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/generate")({
  component: GenerateRedirect,
});

function GenerateRedirect() {
  return <Navigate to="/admin/compose" />;
}
